import { deliveryStore } from '../store/deliveryStore'
import { orderStore } from '../store/orderStore'

import { ShipmentZonesApi } from '../api/ShipmentZonesApi'
// import { ShipmentZones } from '../../core/ShipmentZones'

export const shipmentDayChanging = {
	data () {
		return {
			deliveryStore: deliveryStore.state,
			config: {
				shipmentDayToChange: process.env.NODE_ENV === 'development' ? 2 : 1,
				shipmentDayToImpost: process.env.NODE_ENV === 'development' ? 3 : 2
			},
			$_shipmentDayChanging_active: false
		}
	},

	watch: {
		
	},
	computed: {
		sub () {
			return this.user.subscription
		},

		delivery () {
            return this.deliveryStore
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id)
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id).attributes
        },

		shipmentDayToChange () {
			return this.delivery
				&& this.delivery.shipment_day === this.config.shipmentDayToChange
		},

		user () {
			return this.$root.user
		}
	},
	methods: {
		$_shipmentDayChanging_loadDelivery () {
			if (!this.user) return
			if (!this.user.subscription) return
			return Promise.resolve(1);
        	return deliveryStore.getDelivery({ 
	        	target_type: 'order', 
	        	target_id: this.user.subscription.id,
	        	include: 'address,time-range'
	    	})
        },

        $_shipmentDayChanging_loadShipmentZones () {
        	var src = this.user.subscription.shipment_zone
        	var params = {
				zip_code: src.zip_code,
				country: src.country,
				city: src.city
			}

			if (!params.city) return

				var dm = new ShipmentZonesApi()
				return dm.get(params)

			.then(response => {
				// console.log(response.body.data.resources.find(zone => zone.shipment_day === this.config.shipmentDayToImpost))
			})
        }
	},

	mounted () {
		
	}
}